import { Box, Typography } from '@mui/material';
import { getPlayerIcon, getPlayersStatus } from '@/helpers/players-helper';
import { getTimeShortWithMinutesLongWithYear } from '@/helpers/datetime-helper';
import ClockIcon from '../shared/icons/clock-icon';
import InfoIcon from '../shared/icons/info-icon';
import TipsIcon from '../shared/icons/tips-icon';
import { PLAYER_STATUS } from '@/constants/player-constants';
import CustomSectionWrapper from '@/DesignSystem/wrappers/CustomSectionWrapper';

const JugadoresGeneralStatus = ({ player }) => {
    const status = player?.gs?.s;
    const statusLevel = player?.gs?.sl;

    if (!status || !statusLevel || status === PLAYER_STATUS.OK) {
        return null;
    }

    const recomendacion = player?.gs?.r;
    const info = player?.gs?.si;
    const fecha = player?.gs?.ud;

    return (
        <CustomSectionWrapper title="Estado general del jugador" mt={2}>
            <Box display={'flex'} flexDirection={'column'} gap={1}>
                <Box display={'flex'} alignItems={'center'} gap={0.5} fontSize={14}>
                    {getPlayerIcon(status, statusLevel)}
                    <Typography fontSize={14}>{getPlayersStatus(status, statusLevel)}</Typography>
                </Box>

                {info && (
                    <Typography
                        variant="body2"
                        style={{ margin: 0 }}
                        fontSize={14}
                        display={'flex'}
                        alignItems={'center'}
                        gap={0.5}
                    >
                        <InfoIcon iconWidth={18} />
                        {info}
                    </Typography>
                )}

                {recomendacion && (
                    <Typography variant="body2" style={{ margin: 0 }} fontSize={14}>
                        <TipsIcon iconWidth={20} />
                        {recomendacion}
                    </Typography>
                )}

                {fecha && (
                    <Box
                        style={{ margin: 0 }}
                        textAlign={'right'}
                        fontSize={14}
                        display={'flex'}
                        alignItems={'center'}
                        gap={0.5}
                        justifyContent={'flex-end'}
                    >
                        <ClockIcon width={20} />
                        <Typography fontSize={12}>{getTimeShortWithMinutesLongWithYear(fecha)}</Typography>
                    </Box>
                )}
            </Box>
        </CustomSectionWrapper>
    );
};

export default JugadoresGeneralStatus;
